<template lang="pug">
  .fpui-store-list-item(@click='$emit("click")')
    .item(:class="{ active, beta: item.beta }")
      .item-image
        img(:src="item.getImage()",:alt="item.getName()")
      .item-informations
        .item-name {{ item.getName() || 'fpui.store.list.item.missingname' | translate }}
        .item-description
          | {{ item.getDescription() }}
      .item-bottom
        .item-price
          .must-buy(v-if='!item.owned')
            .price-tag
              span.item-price-tag {{item.getPrice()}}
              | /month/user
          .owned(v-else)
            .installed(v-if='item.installed')
              span(v-if='item.installed == true') {{ "fpstore.packages.installed" | translate([item.name]) }}
            .owned-not-installed(v-if='!item.hasInstall()')
              i.fpui.fpui-check-circle.text-green
        .shortcut-icons
          i.fpui.fpui-pencil(
            @click.stop="$emit('editStore')",
            v-if="item.canUpdate",
            v-tooltip='$t("fpstore.packages.tooltip.editStore", [item.name])'
          )
          span.installation(v-if="item.hasInstall()")
            img.fp-loading.rotating(
              v-if="item.loading"
              :src="spinner"
            )
            i.fpui.fpui-plus(
              @click.stop="install",
              v-if="!item.loading && item.installed == false"
              v-tooltip='$t("fpstore.packages.tooltip.install", [item.name])'
            )
            i.fpui.fpui-remove.remove-button(
              @click.stop="remove",
              v-if="!item.loading && item.installed == true && !isSystem"
              v-tooltip='$t("fpstore.packages.tooltip.remove", [item.name])'
            )
            i.fpui.fpui-settings(
              @click.stop="$emit('edit')",
              v-if="showEdit(item)"
              v-tooltip='$t("fpstore.packages.tooltip.edit", [item.name])'
            )
          span.buy(v-if="!item.hasInstall() && !item.owned")
            i.fa.fa-credit-card(
              @click.stop="$emit('buy')"
              v-tooltip='$t("fpstore.packages.tooltip.buy", [item.name])'
            )
          span.item-information(
            v-tooltip='item.getTooltip()',
            :class='item.getTooltipClass()'
            @click.stop='$emit("detail")'
          )
            i.fpui.fpui-information-circle
</template>

<script>
  export default {
    name: 'FpuiStoreListItem',
    props: {
      item: Object
    },
    computed: {
      active () {
        return this.item.id === this.$store.getters.PACKAGES_ACTIVE && !this.$store.state.packages.installed
      },
      spinner () {
        return require('./ic_spinner.png')
      },
      isSystem () {
        const itemCategories = Array.isArray(this.item.category) ? this.item.category : [this.item.category]
        return itemCategories.includes('System')
      }
    },
    methods: {
      showEdit (item) {
        if (item.consumer === 'app' || item.consumer === 'api') {
          return item.installed === true && item.source && item.source.moduleOptions && Object.keys(item.source.moduleOptions).length > 0
        }
        return false
      },
      install () {
        this.$emit('install')
      },
      remove () {
        this.$emit('remove')
      }
    }
  }
</script>

<style lang="less">
@import "~@/shared/styles/_variables.less";

@keyframes rotating {
  from{
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }
  to{
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}
@-webkit-keyframes rotating {
  from{
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }
  to{
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}

.rotating {
  animation: rotating 1s linear infinite;
  -webkit-animation: rotating 1s linear infinite;
  height: 30px;
  width: 30px;
}

.fpui-store-list-item {
  .item {
    height:120px;
    padding: 10px;
    position: relative;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    border: 2px solid white;
    transition: all 0.25s;
    overflow: hidden;
    &.create {
      text-align: center;
      font-size:20px;
      color:#bbb;
      .create-wrapper {
        position: absolute;
        width: 75%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    &:hover, &.active {
      border-color: @blue;
      background-color: @blueLight;
      .item-informations {
        .item-description:after {
          background-color: @blueLight;
        }
      }
    }
    &:hover {
      cursor: pointer;
    }
    &.beta:before {
      content: 'Beta';
      position: absolute;
      transform:rotate(-45deg);
      width:150px;
      left:-55px;
      text-align: center;
      display: block;
      background:@blue;
      color:white;
      text-transform: uppercase;
      font-size: 12px;
      z-index: 1;
    }
    .item-image {
      text-align: center;
      position:relative;
      height: 100px;
      margin:0 10px 0 0;
      overflow: hidden;
      width: 100px;
      float: left;
      img {
        position: absolute;
        width: 100%;
        max-height: 100px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .item-informations {
      height: 5.8em;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      .item-name {
        position: relative;
        font-size: 12pt;
        padding-top: 5px;
        padding-bottom: 5px;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .item-description {
        overflow: hidden;
        position: relative;
        line-height: 1.2em;
        margin-right: -0.5px;
        padding-right: 1em;
        text-align: justify;
        max-height: 2.4em;
        &:before {
          content: '...';
          position: absolute;
          right: 0;
          bottom: 0;
        }
        &:after {
          content: '';
          position: absolute;
          right: 0;
          width: 1em;
          height: 1em;
          margin-top: 0.2em;
          background-color: white;
          transition: all 0.25s;
        }
      }
    }
    .item-bottom {
      display: flex;
      justify-content: space-between;
      cursor: initial;
      i {
        font-size: large;
      }
      .installed span {
        color:@green;
        line-height: 27px;
      }
      .price-tag {
        font-size: 11px;
        color: darken(@grey, 30%);
        .item-price-tag {
          font-weight: bold;
          font-size: 18px;
          color: @black;
          padding-right: 5px;
        }
      }
      .remove-button {
        font-size: 20px;
        transition:all 300ms;
      }
      .remove-button:hover {
        color:@red;
      }
      .shortcut-icons {
        display: flex;
        align-items: center;
        span {
          margin-left: 5px;
        }
        color: @blue;
        i {
          cursor: pointer;
        }
        .item-information {
          color: @blue;
          font-size: large;
          &:hover {
            cursor: pointer;
          }
          &.yellow {
            color: @yellow;
          }
        }
      }
    }
  }
}
</style>
